import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'linkify',
    standalone: true
})
export class LinkifyPipe implements PipeTransform {
  private targetBlank = urlObj => {
    if (urlObj.reason !== 'email') return { name: 'target', value: 'blank' };
  };

  transform = (value: string = '', options?: any): string => {
    // explicit not !== to catch null
    if (value !== undefined) {
      // TODO ng9 attributes looks wrong, https://github.com/alexcorvi/anchorme.js
      // value = anchorme(value, { attributes: [this.targetBlank], ...options });
    }

    return value;
  };
}
